/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Series_AddInputs */

const en_us2_body_measures_series_add = /** @type {(inputs: Body_Measures_Series_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log again`)
};

const pt_br2_body_measures_series_add = /** @type {(inputs: Body_Measures_Series_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar de novo`)
};

const es_419_body_measures_series_add = /** @type {(inputs: Body_Measures_Series_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar de nuevo`)
};

const pt_pt2_body_measures_series_add = /** @type {(inputs: Body_Measures_Series_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar outra vez`)
};

const fr_fr2_body_measures_series_add = /** @type {(inputs: Body_Measures_Series_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesurer à nouveau`)
};

const de_de2_body_measures_series_add = /** @type {(inputs: Body_Measures_Series_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut eintragen`)
};

const it_it2_body_measures_series_add = /** @type {(inputs: Body_Measures_Series_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra di nuovo`)
};

/**
* | output |
* | --- |
* | "Log again" |
*
* @param {Body_Measures_Series_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_series_add = /** @type {((inputs?: Body_Measures_Series_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Series_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_series_add(inputs)
	if (locale === "es-419") return es_419_body_measures_series_add(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_series_add(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_series_add(inputs)
	if (locale === "de-DE") return de_de2_body_measures_series_add(inputs)
	if (locale === "it-IT") return it_it2_body_measures_series_add(inputs)
	return en_us2_body_measures_series_add(inputs)
});
export { body_measures_series_add as "body-measures.series_add" }